export const ACCOUNT_EXPIRED_MODAL_NAME = 'accountExpired';
